import { useInView } from 'react-intersection-observer'
import { useState, useEffect } from 'react'

import person1 from '../assets/img/persons/male2.jpg'
import person2 from '../assets/img/persons/male.jpg'
import person3 from '../assets/img/persons/female2.jpg'
import spill from '../assets/img/patterns/spill.svg'
import spill2 from '../assets/img/patterns/spill-2.svg'
import { getReviews, urlFor } from '../services/sanity.service'

const fallbackReviews = [
    {
        name: 'David Taboch',
        content: 'בעל מקצוע מעולה ! ביצע אצלי בבית מגוון עבודות , והכל בסופר מקצועיות , הבנה לצרכים שלי , לא עזב את הבית עד שהיה מושלם ! לא מובן מאליו אך כמובן שהשאיר את הבית נקי כאילו לא עבדו בו , מאוד מומלץ !',
        image: person1,
    },
    {
        name: 'חזי דיין',
        content: 'מקצוען עם נשמה ענקית, משלב התכנון ועד הביצוע תמיד עם חיוך , מיקצועי ונקי. חוויה טובה לעבור אצלך שיפוץ אין כמוך. תודה על הכל',
        image: person2,
    },
    {
        name: 'Ravit Tahar',
        content: 'הגענו לאייל דרך הפייסבוק, כבר בטלפון היה נעים לדבר איתו והיה סופר גמיש לצרכים שלנו. תקתק את כל מה שסגרנו והגדיל ראש גם בדברים נוספים שהיינו צריכים. העבודה היתה מקצועית ויפה ואנחנו ממש מרוצים וממליצים. תודה אייל ונתראה 🙂',
        image: person3,
    },
]

export function Reviews() {
    const { ref: reviews, inView: isVisible } = useInView()
    const [reviewsList, setReviewsList] = useState(fallbackReviews)

    useEffect(() => {
        async function loadReviews() {
            const items = await getReviews()
            if (items && items.length > 0) {
                setReviewsList(items.map(item => ({
                    name: item.name,
                    content: item.content,
                    image: item.image ? urlFor(item.image).url() : null,
                })))
            }
        }
        loadReviews()
    }, [])

    return <section
        className={`reviews main-layout full ${isVisible ? 'visible' : ''}`}
        id='reviews'
        ref={reviews}
    >
        <section>
            <h2>
                מביאים לכם תוצאה אמיתית עם השירות הטוב ביותר. כמה <span >מסיפורי ההצלחה</span > שלנו.
            </h2>
            <ul >
                {reviewsList.map((reviewItem, index) => (
                    <li key={index} className="review-container">
                        <p>{reviewItem.content}</p>
                        <h3>{reviewItem.name}</h3>
                        {reviewItem.image && (
                            <img src={reviewItem.image} alt={reviewItem.name} className="client-pic" />
                        )}
                    </li>
                ))}
            </ul>
        </section>
        <img className='spill' src={spill} alt="" />
        <img className='spill2' src={spill2} alt="" />
    </section>
}